import { maximizeValueCards, sliderSettings } from './maximize-business.constants';
import { StyledCard, StyledCardDescription, StyledCardImage, StyledCardTitle, StyledDescription, StyledFadingEdges, StyledHeaderSection, StyledHeading, StyledIcon, StyledSectionWrapper, StyledSlider } from './maximize-business.styles';
export const MaximizeBusiness = () => {
  return <StyledSectionWrapper data-sentry-element="StyledSectionWrapper" data-sentry-component="MaximizeBusiness" data-sentry-source-file="maximize-business.tsx">
      <StyledHeaderSection data-sentry-element="StyledHeaderSection" data-sentry-source-file="maximize-business.tsx">
        <StyledHeading data-sentry-element="StyledHeading" data-sentry-source-file="maximize-business.tsx">How SOC teams use TryHackMe to improve detection and response</StyledHeading>
        <StyledDescription data-sentry-element="StyledDescription" data-sentry-source-file="maximize-business.tsx">
          TryHackMe can be used for every SOC team, every skill level, and every stage of development
        </StyledDescription>
      </StyledHeaderSection>

      <StyledFadingEdges data-sentry-element="StyledFadingEdges" data-sentry-source-file="maximize-business.tsx">
        <StyledSlider {...sliderSettings} data-sentry-element="StyledSlider" data-sentry-source-file="maximize-business.tsx">
          {maximizeValueCards.map(card => <StyledCard key={card.title}>
              <StyledIcon icon={card.icon} />

              <StyledCardTitle>{card.title}</StyledCardTitle>
              <StyledCardDescription>{card.description}</StyledCardDescription>
              <StyledCardImage src={card.image} alt={card.title} />
            </StyledCard>)}
        </StyledSlider>
      </StyledFadingEdges>
    </StyledSectionWrapper>;
};